const STRIPE_ENABLED_COOKIE_KEY = 'ff_stripe_enabled'

function normalizeFlagValue(value) {
  if (value === true || value === 'true' || value === 'on' || value === 1) {
    return true
  }

  if (value === false || value === 'false' || value === 'off' || value === 0) {
    return false
  }

  return null
}

function readCookie(name) {
  if (typeof document === 'undefined') {
    return null
  }

  const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${escapedName}=([^;]*)`)
  )

  if (!match) {
    return null
  }

  return decodeURIComponent(match[1] || '')
}

export function resolveStripeEnabled(publicConfig) {
  const envEnabled = normalizeFlagValue(publicConfig?.stripeEnabled) ?? false
  const cookieValue = readCookie(STRIPE_ENABLED_COOKIE_KEY)
  const cookieDecision = normalizeFlagValue(cookieValue)

  if (typeof cookieDecision === 'boolean') {
    return cookieDecision
  }

  return envEnabled
}
